module.exports = __webpack_public_path__ + "img/lyon-by-night.4f55732b.jpg";